import React from "react";
import FormCreateBusiness from "../../../../molecules/Form/FormCreateBusiness";
import FormSearch from "../../../../molecules/Form/FormSearch";
import { Link } from "react-router-dom";
import { HiOutlineTrash, HiPencilAlt } from "react-icons/hi";

export const DUMMY_DATA_BUSINESS_UNIT = [
  {
    id: 1,
    name: "Smartphone Unit",
    category: { id: 1, name: "Technology" },
    establishDate: "24 January 1994",
  },
  {
    id: 2,
    name: "HR Consultant",
    category: { id: 2, name: "Consultant" },
    establishDate: "16 February 1875",
  },
];

const screen = () => {
  return (
    <>
      <FormSearch />
      <div className="flex mt-4">
        <Link
          to="/business/dashboard/total-business/create"
          className="border-1 rounded-lg p-2 font2 shadow-md"
        >
          + Add Business
        </Link>
      </div>
      <div className="h-full w-full flex flex-col items-center">
        <div className="form-group" style={{ padding: 0 }}>
          <div className="overflow-x-auto relative shadow-md mt-4">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th className="py-3 px-6">No</th>
                  <th className="py-3 px-6">Business Unit</th>
                  <th className="py-3 px-6">Category</th>
                  <th className="py-3 px-6">Establish Date</th>
                  <th className="py-3 px-6">Action</th>
                </tr>
              </thead>
              <tbody>
                {DUMMY_DATA_BUSINESS_UNIT.map((el, index) => {
                  return (
                    <tr className="bg-white border-b" key={index}>
                      <td className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap">
                        {el.id}
                      </td>
                      <td className="py-4 px-6">{el.name}</td>
                      <td className="py-4 px-6">{el.category.name}</td>
                      <td className="py-4 px-6">{el.establishDate}</td>
                      <td className="py-4 px-6 flex">
                        <a href="" className="mr-2">
                          <HiPencilAlt />
                          Edit
                        </a>
                        <a href="">
                          <HiOutlineTrash />
                          Delete
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default screen;
